import { useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../app/store";
import authInterceptor from "../../app/api/authInterceptor";
import { findUserTokenInStorage } from "../../app/store/auth/authActions";
import { USER_TOKEN } from "../../app/store/auth/authMiddleware";

export default function useAuth() {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const userTokenRedux = useSelector(
    (state: State) => state.auth.userToken,
    (oldToken, newToken) => oldToken.sessionToken === newToken.sessionToken
  );
  const tokenInSession = sessionStorage.getItem(USER_TOKEN);
  const userToken = tokenInSession ? JSON.parse(tokenInSession) : userTokenRedux;
  const isLoggedIn = useSelector((state: State) => state.auth.isLoggedIn);

  useLayoutEffect(() => {
    dispatch(findUserTokenInStorage());
  }, [dispatch]);

  useLayoutEffect(() => {
    authInterceptor(userToken.sessionToken);
    setLoading(false);
  }, [userToken]);

  return { isLoggedIn, loading };
}
